<template>
    <CieloLayout layout-version="v1">
        <div class="container text-muted payment-success">
            <img class="d-block mx-auto my-4" src="@/assets/img/payment-success.svg" alt="" tabindex="-1" />

            <loggi-message v-if="shippingMethod && shippingMethod.shippingTypeLoggi" />
            <BoletoMessage
                v-if="selectedPaymentMethod &&
                    selectedPaymentMethod.PaymentType == PaymentTypes.BOLETO
                "
            />
            <div v-else>
                <p class="payment-success-title text-center my-4" v-text="$ml.get('paymentSuccessTitle')" tabindex="0" />

                <p class="payment-success-detail text-center my-4">
                    <span v-text="$ml.get('PaymentSuccessDetail')" tabindex="0" />
                </p>
            </div>

            <hr class="my-4" />

            <div class="mb-5">
                <CartOverview />
            </div>

            <div class="payment-success__container--item-description" v-if="firstItemDescription">
                <CartItemDescription 
                    :item-description="firstItemDescription"
                    :is-short-description="renderMobile()"
                />
            </div>

            <div v-if="shippingAddress.ShippingAddress.ZipCode != null">
                <p class="payment-success-shipping-address text-left mb-1" v-text="$ml.get('deliveryAddress')" tabindex="0" />
                <p class="text-left" tabindex="0">
                    {{ shippingAddress.ShippingAddress.ZipCode }} -
                    {{ shippingAddress.ShippingAddress.Street }},
                    {{ shippingAddress.ShippingAddress.Number }}
                    {{ shippingAddress.ShippingAddress.District }}
                    {{ shippingAddress.ShippingAddress.City }} -
                    {{ shippingAddress.ShippingAddress.State }}
                </p>
                <p class="text-left" v-if="shippingAddress.ShippingAddress.Compl" tabindex="0">
                    {{ shippingAddress.ShippingAddress.Compl }}
                </p>
            </div>

            <OrderOverview class="mb-5" />
        </div>
    </CieloLayout>
</template>

<script>
const CieloLayout = () =>
	import(/* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout');
import OrderOverview from '@/components/OrderOverview/OrderOverview';
import { mapGetters, mapState } from 'vuex';
import store from '@/store';
import CartOverview from '@/components/CartOverview';
import LoggiMessage from './components/LoggiMessage';
import BoletoMessage from './components/BoletoMessage';
import PaymentTypes from '@/models/PaymentTypes';
import CartItemDescription from '@/components/CartItemDescription';
import { MLBuilder } from 'vue-multilanguage';
import { isMobile } from '@/helpers/isMobile';


export default {

  data() {
      return {
          firstItemDescription: '',
      };
  },

	components: {
		CieloLayout,
		OrderOverview,
		CartOverview,
		LoggiMessage,
		BoletoMessage,
    CartItemDescription,
	},

	computed: {
		...mapGetters({
			formattedPrice: 'payment/getFormattedPrice',
			billingAddress: 'billingAddress/getSubmitModel',
			shippingMethod: 'shippingType/getMethod',
			shippingAddress: 'shippingAddress/getSubmitModel',
			selectedPaymentMethod: 'payment/getSelectedPaymentMethod'
		}),

    ...mapState({
        merchantName: state => state.preorder.MerchantName,
        items: state => state.cart.Items,
    }),

		mlPaymentSuccessDetail() {
			return new MLBuilder('paymentSuccessDetail').with(
				'0',
				this.merchantName
			);
		},

    getFirstItemDescription() {
        const { Description } = this.items.find((item) => item.Description) || {};

        return Description;
    },
	},

	created() {
		this.PaymentTypes = PaymentTypes;
    this.firstItemDescription = this.getFirstItemDescription;
	},

	beforeRouteEnter(to, from, next) {
		if (!store.state.preorder.TransactionIsFinalized) return next(false);

		next();
	},

	beforeRouteLeave(to, from, next) {
		next(false);
	},

  methods: {
      renderMobile() {
        return isMobile();
      }
  }
};
</script>

<style lang="scss" scoped>
    .payment-success {

        &__container--item-description {
            margin-bottom: 40px;
        }
    }

.payment-success-title {
	font-weight: 700;
	font-size: 16px;
	color: #43b977;
}

.payment-success-detail {
	font-size: 16px;
	color: #425865;
}

.payment-success-overview {
	font-weight: 700;
	font-size: 16px;
	color: #145eb3;
}

.payment-success-shipping-address {
	font-weight: 700;
	font-size: 16px;
	color: #5a646e;
}

.top-icon {
	width: 52px;
	height: 52px;
	margin-top: -26px;
	background: #fff;
	border-radius: 50px;
}

.message-title,
.total-title,
.total-price {
	display: block;
}

.message-title {
	font-weight: 900;
	color: #074776;
	font-size: 16px;
	margin-top: 15px;
}

.total-title {
	font-weight: 500;
	font-size: 14px;
	color: #363636;
	margin-top: 17px;
}

.total-price {
	font-weight: 500;
	font-size: 26px;
	color: $cielo-blue;
	margin-top: 4px;
	margin-bottom: 19px;
}
</style>
